import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'reverse' ).path;
